import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    Typography,
} from "@mui/material";
import React from "react";

type CreateProxyDialogProps = {
    open: boolean;
    fileName: string;
    hd: boolean;
    submitting?: boolean;
    onHdChange: (hd: boolean) => void;
    onClose: () => void;
    onProceed: () => void;
};

const CreateProxyDialog = ({
    open,
    fileName,
    hd,
    submitting = false,
    onHdChange,
    onClose,
    onProceed,
}: CreateProxyDialogProps) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Create a Temporary Video Proxy for MOV File
            </DialogTitle>
            <DialogContent>
                <DialogContentText component="div">
                    <Typography sx={{ mb: 2 }}>
                        By click &quot;Proceed&quot; Canvas will transcode the
                        selected file using AWS Elemental and provide a
                        temporary CloudFront link (about 72 hours; S3 may
                        remove the file between 72–96 hours).
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        File name: <strong>{fileName || "—"}</strong>
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hd}
                                onChange={(e) => onHdChange(e.target.checked)}
                                disabled={submitting}
                            />
                        }
                        label="HD version instead"
                    />
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1, ml: 4 }}
                    >
                        {hd ? (
                            <>
                                Aspect: Match Source
                                <br />
                                Frame Rate: Match Source
                                <br />
                                Resolution: HD 1920x1080
                                <br />
                                Bit Rate: 16 Mbps
                                <br />
                                Audio: Stereo AAC
                            </>
                        ) : (
                            <>
                                Resolution: 270p (width keeps aspect ratio)
                                <br />
                                Video: H.264 QVBR (max 500 kbps)
                                <br />
                                Audio: Stereo AAC 96 kbps
                            </>
                        )}
                    </Typography>
                    <Typography sx={{ mt: 2 }} variant="body2">
                        The link will be posted once transcoding is complete…
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button
                    onClick={onProceed}
                    variant="contained"
                    disabled={submitting || !fileName}
                >
                    Proceed
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateProxyDialog;
